import { render, staticRenderFns } from "./BusinessPlan.vue?vue&type=template&id=3c23459e&scoped=true"
import script from "./BusinessPlan.vue?vue&type=script&lang=js"
export * from "./BusinessPlan.vue?vue&type=script&lang=js"
import style0 from "./BusinessPlan.vue?vue&type=style&index=0&id=3c23459e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23459e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c23459e')) {
      api.createRecord('3c23459e', component.options)
    } else {
      api.reload('3c23459e', component.options)
    }
    module.hot.accept("./BusinessPlan.vue?vue&type=template&id=3c23459e&scoped=true", function () {
      api.rerender('3c23459e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Journal/BusinessPlan.vue"
export default component.exports